"use client";

import { useEffect } from "react";
import styles from "./page.module.css";
import { useAddClientsStore } from "./useAddClientsStore";
import { useUserAuthDataContext } from "@/global-context/user-auth-context";
import { useRouter } from "@/i18n/navigation";

export default function AddClientsPage() {
  const { userData } = useUserAuthDataContext();
  const {
    formData,
    isSending,
    changeFormField,
    clients,
    addClient,
    initClients,
  } = useAddClientsStore();
  const router = useRouter();
  useEffect(() => {
    if (userData.sessionId === "") {
      router.push("/");
    }
    initClients(userData.sessionId);
  }, [userData]);
  return (
    <main className={styles.main}>
      <h2 className={styles.title}>Add clients</h2>
      <form action="" className={styles.form}>
        <fieldset className={styles.fieldSet}>
          <legend className={styles.legend}>First name</legend>
          <input
            className={styles.input}
            name="first-name"
            type="text"
            placeholder="Enter first name..."
            value={formData.first_name}
            onChange={(e) => {
              changeFormField("first_name", e.target.value);
            }}
          />
        </fieldset>
        <fieldset className={styles.fieldSet}>
          <legend className={styles.legend}>Last name</legend>
          <input
            className={styles.input}
            name="last-name"
            type="text"
            placeholder="Enter last name..."
            value={formData.last_name}
            onChange={(e) => {
              changeFormField("last_name", e.target.value);
            }}
          />
        </fieldset>
        <fieldset className={styles.fieldSet}>
          <legend className={styles.legend}>Phone Number</legend>
          <input
            className={styles.input}
            name="phone-number"
            type="text"
            placeholder="Enter phone number..."
            value={formData.phone_number}
            onChange={(e) => {
              changeFormField("phone_number", e.target.value);
            }}
          />
        </fieldset>
        <fieldset className={styles.fieldSet}>
          <legend className={styles.legend}>Email</legend>
          <input
            className={styles.input}
            name="email"
            type="text"
            placeholder="Enter email..."
            value={formData.email}
            onChange={(e) => {
              changeFormField("email", e.target.value);
            }}
          />
        </fieldset>
        <button
          disabled={isSending}
          type="submit"
          className={styles.sendButton}
          onClick={async (e) => {
            e.preventDefault();
            await addClient(userData.sessionId);
          }}
        >
          Send
        </button>
      </form>
      <h4 className={styles.latestTitle}>
        Latest added users ({clients.length})
      </h4>
      <table className={styles.table}>
        <thead className={styles.tableHeader}>
          <tr>
            <th className={styles.tableHeaderText}>First name</th>
            <th className={styles.tableHeaderText}>Last name</th>
            <th className={styles.tableHeaderText}>Phone number</th>
            <th className={styles.tableHeaderText}>Email</th>
            <th className={styles.tableHeaderText}>Added at</th>
          </tr>
        </thead>
        <tbody className={styles.tableBody}>
          {clients.map((client, _) => {
            return (
              <tr key={client.id}>
                <td className={styles.tableBodyText}>{client.first_name}</td>
                <td className={styles.tableBodyText}>{client.last_name}</td>
                <td className={styles.tableBodyText}>{client.phone_number}</td>
                <td className={styles.tableBodyText}>{client.email}</td>
                <td className={styles.tableBodyText}>
                  {new Date(client.added_at).toLocaleDateString("en-US", {
                    month: "short",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false,
                  })}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </main>
  );
}
